module.exports = __webpack_public_path__ + "static/img/刘文虎B.1dfcddd9.png";